import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-nocheck
import { safeCssUrl } from '../../common/utils/safeCssUrl';

// `m` is the Flarum-provided global (JSX pragma); don't import from 'mithril'.

/**
 * Wraps the avatar vnode with a decoration frame. The frame is a `<span>`
 * pinned absolutely over the avatar element via the `.ps-avatar-deco` class
 * defined in less/forum.less.
 *
 * Critically: Avatar.view returns an `<img>` when the user has an uploaded
 * picture (a self-closing element that can't take children). So we MUTATE
 * the vnode in place into a wrapping `<span>` and demote the original
 * tag/attrs into a fresh child vnode. Both shapes (img and the fallback span)
 * get handled the same way.
 */

export function applyAvatarDecoration(vnode, frameUrl, opts) {
  var _vnode$attrs, _vnode$attrs$includes;
  if (opts === void 0) {
    opts = {};
  }
  if (!vnode || !frameUrl) return;

  // Don't decorate twice if this view() is re-run on the same vnode.
  if ((_vnode$attrs = vnode.attrs) != null && (_vnode$attrs = _vnode$attrs.className) != null && (_vnode$attrs$includes = _vnode$attrs.includes) != null && _vnode$attrs$includes.call(_vnode$attrs, 'ps-avatar-deco-wrap')) return;
  const innerVnode = {
    tag: vnode.tag,
    attrs: _objectSpread({}, vnode.attrs || {}),
    children: vnode.children,
    text: vnode.text
  };
  const previousOncreate = innerVnode.attrs.oncreate;
  vnode.tag = 'span';
  vnode.attrs = {
    className: 'ps-avatar-deco-wrap ' + (innerVnode.attrs.className || ''),
    style: innerVnode.attrs.style,
    'data-ps-deco': '1'
  };

  /*
   * `skipInDiscussionList` é o ÚNICO contexto que precisa de JS — está
   * gated por uma configuração do admin que pode ser ligada/desligada.
   * Os contextos NEVER_DECORATE (PostPreview, Post-mentionedBy*) viviam
   * aqui também mas geravam "avatar duplicado": ao remover a classe
   * `.ps-avatar-deco-wrap`, perdíamos a regra `background: transparent`
   * E o wrap (que tem `.Avatar` herdado do className do inner) virava
   * um SEGUNDO avatar visível ao lado do inner por causa do
   * `.PostPreview .Avatar { float: left; margin-left: -50px }` de
   * Flarum core (Post.less:348) que aplicava em BOTH wrap e inner.
   * Movido para CSS em forum.less (`.PostPreview .ps-avatar-deco-wrap
   * { display: contents }`) — assim o wrap some do layout e só o inner
   * recebe o estilo do PostPreview. Sem flicker em updates de Mithril,
   * sem duplicação visual.
   */
  const LIST_SELECTOR = '.DiscussionListItem, [class*="AvocadoHome-thread"]';
  vnode.attrs.oncreate = n => {
    var _el$closest;
    const el = n.dom;
    if (el && opts.skipInDiscussionList && (_el$closest = el.closest) != null && _el$closest.call(el, LIST_SELECTOR)) {
      el.classList.remove('ps-avatar-deco-wrap');
      el.removeAttribute('data-ps-deco');
      const frame = el.querySelector(':scope > .ps-avatar-deco');
      frame == null || frame.remove();
    }
    previousOncreate == null || previousOncreate(n);
  };
  vnode.text = undefined;
  vnode.children = [innerVnode, m('span.ps-avatar-deco', {
    style: {
      backgroundImage: "url(\"".concat(safeCssUrl(frameUrl), "\")")
    },
    'aria-hidden': 'true'
  })];
}
flarum.reg.add('ramon-point-system', 'forum/utils/applyAvatarDecoration', { applyAvatarDecoration: applyAvatarDecoration, });